import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useContext, useState } from 'react';
import { noop } from 'es-toolkit';

export type Layout = 'desktop' | 'tablet' | 'mobile';

export type ILayoutContext = {
  layout: Layout | undefined;
  setLayout: Dispatch<SetStateAction<Layout | undefined>>;
};

const LayoutContext = createContext<ILayoutContext>({
  layout: undefined,
  setLayout: noop
});

export function LayoutProvider({ children }: PropsWithChildren) {
  const [layout, setLayout] = useState<Layout | undefined>(undefined);

  return (
    <LayoutContext.Provider
      value={{
        layout,
        setLayout
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
}

export const useLayout = () => {
  return useContext(LayoutContext);
};
